import React from "react";
import { FormControl, FormLabel, Input } from "@chakra-ui/react";

const MyInput = ({
  value,
  onChange,
  required,
  label,
  placeholder,
  type,
  size = "md",
  readOnly = false,
  error = false,
}) => {
  return (
    <FormControl isRequired={required}>
      <FormLabel fontSize="sm">{label}</FormLabel>
      <Input
        placeholder={placeholder}
        value={value}
        type={type || "text"}
        onChange={onChange}
        variant="outline"
        // disabled={disabled}
        readOnly={readOnly}
        size={size}
        borderRadius="md"
        bgColor={"white"}
        _placeholder={{ color: "gray.400" }}
        isInvalid={!!error}
      />
      {!!error && <span className="mt-1 text-xs text-red-500">{error}</span>}
    </FormControl>
  );
};

export default MyInput;
